module.exports = __webpack_public_path__ + "media/images/badges/stride/milestone-1_inactive-75c76d33566147d2bfa705677d888784.svg";